import { render, staticRenderFns } from "./analytics.vue?vue&type=template&id=2c08a542&"
import script from "./analytics.vue?vue&type=script&lang=js&"
export * from "./analytics.vue?vue&type=script&lang=js&"
import style0 from "./analytics.vue?vue&type=style&index=0&id=2c08a542&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_68125b3067bc9264b7f5e63a32c23d52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports